<template lang="pug">
include ./../../../mixins
+b.pagination-wrapper(v-if="page")
  +b.pagination(v-if="page && range.max > 1")
    +e.SPAN.button--previous(
      v-if='page.hasPrevious()',
      @click.prevent="previous()"
    )
      +b.I.icon.icon-arrowb-right-short
    +e.SPAN.item(
      v-if="page.hasPrevious()",
      @click.prevent="select(range.min)"
    ) {{ range.min }}
    +e.SPAN.item--dots(v-if="gaps.left") ...
    +e.SPAN.item(
      v-for="page in fills.left",
      @click.prevent="select(page)"
    ) {{ page }}
    +e.SPAN.item.is-active {{ page.getPageNumber() }}
    +e.SPAN.item(
      v-for="page in fills.right",
      @click.prevent="select(page)"
    ) {{ page }}
    +e.SPAN.item--dots(v-if="gaps.right") ...
    +e.SPAN.item(
      v-if="page.hasNext()",
      @click.prevent="select(range.max)"
    ) {{ range.max }}
    +e.SPAN.button--next(
      v-if='page.hasNext()',
      @click.prevent="next()"
    )
      +b.I.icon.icon-arrowb-right-short
</template>

<script>
/* eslint-disable prefer-spread */
import { LimitOffsetPagination } from './Pagination'

export default {
  name: 'UiLimitPagination',

  props: {
    pagination: {},
    extra: {
      type: Number,
      default: 2,
    },
    needAddBtns: {
      type: Boolean,
      default: () => false,
    },
    reset: {},
  },

  data() {
    return {
      pageSizes: [10, 20, 40, 60, 80],
      pagelimit: 10,
      page: {},
      range: {
        min: 0,
        max: Infinity,
      },
      gaps: {
        left: false,
        right: false,
      },
      fills: {
        left: [],
        right: [],
      },
      one: 1,
      zero: 0,
      limit: 200,
      show: true,
    }
  },

  created() {
    if (this.page) this.recalcRange()
  },

  computed: {
    pageObj() {
      const to = this.page.limit + this.page.offset
      const from = this.page.offset + this.one
      return { to, from }
    },
  },

  watch: {
    pagination: {
      deep: true,
      immediate: true,
      handler() {
        this.page = new LimitOffsetPagination(this.pagination)
        this.pagelimit = this.pagination.limit
        this.show = true
      },
    },

    page() {
      this.recalcRange()
    },

    reset(nval) {
      if (nval) {
        this.show = true
      }
    },
  },

  methods: {
    recalcRange() {
      const [min, max] = this.page.getPageRange()
      const current = this.page.getPageNumber()
      const [start, end] = this.page.getPageRange(this.extra, current)
      const range = Array.apply(null, { length: end - start + this.one }).map(
        (x, i) => i + start
      )
      const currentIndex = range.indexOf(current)
      if (currentIndex !== -this.one) {
        this.fills.left = range.slice(this.zero, currentIndex)
        const minIndex = this.fills.left.indexOf(min)
        if (minIndex >= this.zero) {
          this.fills.left.splice(minIndex, this.one)
        }
        this.fills.right = range.slice(currentIndex + this.one)
        const maxIndex = this.fills.right.indexOf(max)
        if (maxIndex >= this.zero) {
          this.fills.right.splice(maxIndex, this.one)
        }
      } else {
        this.fills.left = []
        this.fills.right = this.fills.left
      }

      this.gaps.left =
        this.fills.left.length && this.fills.left[0] !== min + this.one
      this.gaps.right =
        this.fills.right.length &&
        this.fills.right[this.fills.right.length - this.one] !== max - this.one
      this.range.min = min
      this.range.max = max
    },

    select(number) {
      this.emitValue(this.page.getParameters(number))
    },

    next() {
      this.emitValue(this.page.next())
    },

    previous() {
      this.emitValue(this.page.previous())
    },

    changeLimit(val) {
      this.emitValue({ limit: val })
    },

    emitValue(val) {
      this.$emit('input', val)
    },
  },
}
</script>
